import { grayColor, infoIconGrayColor } from "assets/jss/material-dashboard-pro-react";

const chargeBannerStyles = () => ({
	infoIcon: {
		color: infoIconGrayColor
	},
	chargeBannerWrapper: {
		padding:'0px 20px 20px'
	},
	infoMessageContainer: {
		backgroundColor: grayColor[1],
		display: "flex",
		padding: "10px",
		alignItems: "center",
		borderRadius: "5px"
	},
	infoiconWrapper : {
		padding: "10px",
		display: "flex"
	},
	messageWrapper: {
		padding: "10px 10px 10px 0px"
	}
});

export default chargeBannerStyles;